<template>
<div class="rounded">
	<div style="height: 150px;"></div>
	<div class="ml-2 input-group">
			<input type="text"
				class="form-control border-0 bg-light mb-5"
				placeholder="Search products..." v-model="search">
			<div class="input-group-append border-0 mb-5">
				<div class="mr-3 p-2 cursor-pointer" @click="search = ''">&times;</div>
			</div>
	</div>
	<div class="d-flex justify-content-between" v-if="products">
		<button class="btn" @click="getProducts()">
			<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="getting_products"></span>
			<vue-fontawesome v-else icon="refresh"></vue-fontawesome>
		</button>
		<!-- top pagination for paginated product data-->
		<div class="d-flex justify-content-end" v-if="products.length > 100">
			<button class="btn" @click="prevPage"
				:disabled="pageNumber == 0">
				<i class="arrow left"></i>
			</button>
			<span class="p-3">{{pageNumber + 1}} / {{pageCount}}</span>
			<button class="btn" @click="nextPage"
				:disabled="(pageNumber+1) == pageCount">
				<i class="arrow right"></i>
			</button>
		</div>
	</div>
	<div class="bg-white" style="height: 100vh; overflow-y:scroll">
		<table class="table table-borderless paginate"
			id="search-products-table"
			data-pagecount="3"
			v-if="products">
			<thead >
				<tr>
				<th scope="col"></th>
				<th scope="col"
					@click="$sortTable(1,'search-products-table')">
					<i class="arrow up"></i>
					product
				</th>
				<th scope="col"
					@click="$sortTable(2,'search-products-table')">
					<i class="arrow up"></i>
					price
				</th>
				</tr>
			</thead>
			<tbody v-if="products && products.length">
				<!-- initially selected row -->
				<tr class="d-none">
					<td  id='start'>0</td>
					<td>1</td>
					<td>2</td>
				</tr>
				<tr class="cursor-pointer"
					v-for="product in paginatedData"
					:key="product.id"
					@click="selectProduct(product)">
					<td style="border-radius:5px; height: 3px; width: 3px;"></td>
					<td>
						<span>
							{{product.name}}<br/>
							<small>{{product.sku}}</small>
						</span>
					</td>
					<td>{{product.retail_price | intcomma}}</td>
				</tr>
			</tbody>
		</table>
	</div>
	<!-- Trigger/Open The Modal -->
	<button type="button"
		class="d-none"
		id="launchModalButton">
		Launch product modal
	</button>

	<!-- The Modal -->
	<div id="myModal" class="modal">
		<!-- Modal content -->
		<button type="button" class="close close-span" aria-label="Close">
				<span aria-hidden="true">&times;</span>
		</button>
		<div class="modal-content" v-if="modal_data.product">
			<div class="modal-header border-0">
				<h5 class="modal-title font-weight-bold" id="exampleModalCenterTitle">{{modal_data.product.name}}</h5>
			</div>
			<div class="modal-body" style="height: 55vh; overflow-y: scroll">
				<section>
					<!-- variants  -->
					<ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
					<li class="nav-item" v-for="(variant,index) in modal_data.product.variations" :key="index">
						<a class="nav-link"
							:class="{ 'active': index === 0 }"
							id="pills-home-tab"
							data-toggle="pill"
							:href="`#pills-${$slugify(variant.name)}`"
							role="tab"
							:aria-controls="`pills-${$slugify(variant.name)}`"
							aria-selected="true">
							{{variant.name}}
						</a>
					</li>
					</ul>
					<div class="tab-content" id="pills-tabContent">
					<div class="tab-pane fade show"
							role="tabpanel"
							v-for="(variant,index) in modal_data.product.variations" :key="index"
							:class="{ 'active': index === 0 }"
							:id="`pills-${$slugify(variant.name)}`" >
						<div class="d-flex">
							<div class="ml-3 form-check" v-for="(value,index) in variant.values" :key="index">
								<input class="form-check-input"
									type="radio"
									:value="{'variant':variant.name,'value':value}"
									:checked="index === 0"
									v-model="modal_data.selection.variant">
								<label class="form-check-label" for="exampleRadios1">
								{{value}}
								</label>
							</div>
						</div>
					</div>
					<hr>
					</div>
					<!-- amount -->
					<div class="mt-3 d-flex justify-content-between">
						<span class="p-2">Quantity</span>
						<input type="number"
							class="col-lg-6 ml-4 form-control"
							id="exampleInputEmail1"
							aria-describedby="emailHelp"
							v-model="modal_data.selection.quantity">
					</div>
					<div class="mt-3 d-flex justify-content-between" v-if="context == 'purchases'">
						<span class="p-2">Buying price</span>
						<input type="number"
							class="col-lg-6 ml-4 form-control"
							id="exampleInputEmail1"
							aria-describedby="emailHelp"
							v-model="modal_data.product.purchase_price">
					</div>
					<div class="mt-3 d-flex justify-content-between" v-if="context == 'purchases'">
						<span class="p-2">Base price</span>
						<input type="number"
							class="col-lg-6 ml-4 form-control"
							id="exampleInputEmail1"
							aria-describedby="emailHelp"
							v-model="modal_data.product.base_selling_price">
					</div>
					<div class="mt-3 d-flex justify-content-between" v-if="modal_data.selection.price_type == 'retail' || modal_data.selection.price_type == null">
						<span class="p-2">Retail price</span>
						<input type="number"
							class="col-lg-6 ml-4 form-control"
							id="exampleInputEmail1"
							aria-describedby="emailHelp"
							v-model="modal_data.product.retail_price">
					</div>
					<div class="mt-3 d-flex justify-content-between" v-if="modal_data.selection.price_type == 'wholesale' || modal_data.selection.price_type == null">
						<span class="p-2">Wholesale price</span>
						<input type="number"
							class="col-lg-6 ml-4 form-control"
							id="exampleInputEmail1"
							aria-describedby="emailHelp"
							v-model="modal_data.product.wholesale_price">
					</div>
					<div class="mt-3 d-flex justify-content-between" v-if="context == 'purchases'">
						<span class="p-2">Amount paid</span>
						<input type="number"
							class="col-lg-6 ml-4 form-control"
							id="exampleInputEmail1"
							aria-describedby="emailHelp"
							v-model="modal_data.selection.price">
					</div>
					<hr v-if="context == 'sales'">
					<div class="d-flex justify-content-center">
					<div class="ml-4 form-check" v-if="context == 'sales'">
						<input class="form-check-input" type="radio" value="retail"
							checked
							v-model="modal_data.selection.price_type">
						<label class="form-check-label">
							Retail
						</label>
					</div>
					<div class="form-check ml-4" v-if="context == 'sales'">
						<input class="form-check-input" type="radio" value="wholesale"
							v-model="modal_data.selection.price_type">
						<label class="form-check-label">
							Wholesale
						</label>
					</div>
					</div>
				</section>
			</div>
			<div class="modal-footer border-0">
				<button class="btn btn-secondary" @click="closeModal()">Cancel</button>
				<button type="button" class="btn btn-success" @click="pickProduct()">Pick product</button>
			</div>
		</div>
	</div>

	<!-- modal -->
	<!-- Button trigger modal -->
</div>
</template>

<script>
export default {
	name: 'SearchProducts',
	props: {
		msg: String,
		context : String,
		update_products: Boolean,
	},
	data(){
		return{
			//paginate products list
			pageNumber: 0,  // default to page 1
            size:100,
            //search
			search:'',
			getting_products: false,
			products:null,
			//modal data.
			modal_data:{
				"product": null,
				'selection':{
					"variant":null,
					"price_type": 'retail',
					"quantity":1,
					'price':0
				}
			}
		}
	},
	created(){
		this.getProducts()
	},
	mounted(){
		this.createCustomModal()
	},
	computed:{
		account_switched(){
			return this.$store.state.account_switch_count
		},
		pageCount(){
			let l = this.products.length,
				s = this.size;
			return Math.ceil(l/s);
		},
		paginatedData(){
			const start = this.pageNumber * this.size,
			end = start + this.size
			if (! this.search.length){
				return this.products.slice(start, end)
			}
			else{
				var filtered_list = this.products.filter((p)=>{
					return p.name.toUpperCase().includes(this.search.toUpperCase())
				})
				return filtered_list.slice(start, end);
			}
		}
	},
	watch:{
		account_switched: function(){
			this.getProducts()
		},
        search: function(){
            if (this.search){
                this.pageNumber = 0
            }
        },
		update_products: function(){
			if (this.update_products){
				this.getProducts()
				this.update_products = false
			}
		}
	},

	methods:{
		nextPage(){
            this.pageNumber++
        },
        prevPage(){
            this.pageNumber--
        },
		//get_products
		getProducts: function(){
			this.getting_products = true
			this.$http({
				method:'get',
				url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/products/`,
				headers:{
					Authorization: JSON.parse(localStorage.getItem('auth_token'))
				}
			}).then((response)=>{
				this.getting_products = false
				this.products = response.data
			}).catch((err)=>{
				this.getting_products = false
				this.$emit('alert',err)
			})
		},
		//select product.
		selectProduct: function(product){
			document.getElementById('launchModalButton').click()
			this.modal_data.product = product
		},
		//pick product.
		pickProduct: function(){
			if (this.modal_data.selection.price_type){
				if (this.modal_data.selection.price_type == 'retail'){
					this.modal_data.selection.price = this.modal_data.product.retail_price
				}
				if (this.modal_data.selection.price_type == 'wholesale'){
					this.modal_data.selection.price = this.modal_data.product.wholesale_price
				}
				//emit to parent the selection.
				this.search = ''
				this.$emit('productPicked',this.modal_data)
				this.modal_data={
					"product": null,
					'selection':{
						"variant":null,
						"price_type": 'retail',
						"quantity":1,
						'price':0
					}
				}
				//close modal
				var span = document.getElementsByClassName("close-span")[0];
				span.click()
			}
			else{
				if (this.context === "sales"){
					alert("pick price (retail or wholesale)")
				}
				if (this.context === "purchases"){
					this.search = ''
					this.$emit('productPicked',this.modal_data)
					this.modal_data={
					"product": null,
					'selection':{
						"variant":null,
						"price_type": null,
						"quantity":1,
						'price':0
					}
				}
					span = document.getElementsByClassName("close-span")[0];
					span.click()
				}
			}
		},
		//custom modal to avoid conflict with bootstrap:
		createCustomModal: function(){
			// Get the modal
			var modal = document.getElementById("myModal");
			// Get the button that opens the modal
			var btn = document.getElementById("launchModalButton");
			// Get the <span> element that closes the modal
			var span = document.getElementsByClassName("close-span")[0];
			// When the user clicks on the button, open the modal
			btn.onclick = function() {
				modal.style.display = "block";
			}

			// When the user clicks on <span> (x), close-span the modal
			span.onclick = function() {
				modal.style.display = "none";
			}

			// When the user clicks anywhere outside of the modal, close-span it
			window.onclick = function(event) {
				if (event.target == modal) {
					modal.style.display = "none";
				}
			}
		},

		closeModal: function(){
			var span = document.getElementsByClassName("close-span")[0];
			span.click()
		}
	},
}
</script>
<style scoped>
	/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-content {
	top: 0;
	width: 40%;
	margin: auto; /* 15% from the top and centered */
	padding: 20px;
	border: 1px solid #888;
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>
